import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", { fill: "currentColor" }, [
      createElementVNode("path", { d: "M7.28 12.75h1.44L8 10.73z" }),
      createElementVNode("path", { d: "M19.83 0H4.17A4.19 4.19 0 0 0 0 4.17v15.66A4.19 4.19 0 0 0 4.17 24h15.66A4.19 4.19 0 0 0 24 19.83V4.17A4.19 4.19 0 0 0 19.83 0m-9.08 16.21a.7.7 0 0 1-.25 0 .75.75 0 0 1-.71-.5l-.47-1.33a.26.26 0 0 0-.24-.17H6.92a.26.26 0 0 0-.24.17l-.47 1.33a.75.75 0 0 1-1.42-.5l2.5-7a.75.75 0 0 1 1.42 0l2.5 7a.75.75 0 0 1-.46 1m3.5-.71a.75.75 0 0 1-1.5 0v-7a.75.75 0 0 1 1.5 0ZM19 11.25h-.5a.25.25 0 0 0-.25.25v3a.25.25 0 0 0 .25.25.75.75 0 0 1 0 1.5 1.76 1.76 0 0 1-1.75-1.75v-3a.25.25 0 0 0-.25-.25H16a.75.75 0 0 1 0-1.5h.5a.25.25 0 0 0 .25-.25v-1a.75.75 0 0 1 1.5 0v1a.25.25 0 0 0 .25.25h.5a.75.75 0 0 1 0 1.5" })
    ], -1)
  ]));
}
const computerKeyboardAlt = { render };
export {
  computerKeyboardAlt as default,
  render
};
//# sourceMappingURL=computer-keyboard-alt.svg.js.map
